/** Accounts you sell to, as cards, with open-deal value on each. */
import { useApp } from '../store/AppContext.jsx';
import Icon from '../lib/icons.jsx';
import { avatarClass } from '../lib/format.js';
import { Card, CardHead, EmptyState, Pill } from '../components/Primitives.jsx';
import { TileRow } from '../components/StatCards.jsx';
import CrmFilter from '../components/CrmFilter.jsx';
import CompanyTable from '../components/CompanyTable.jsx';
import ViewToggle from '../components/ViewToggle.jsx';
import { filterCompanies, isOpen } from '../domain/crm.js';

export default function Companies() {
  const { crm, rows, cF, crmMode, pipeline, fmtMoney, setSheet } = useApp();
  const list = filterCompanies(crm, cF);

  return (
    <>
      <TileRow
        tiles={[
          ['Companies', crm.companies.length, 'building', 'g-cyan'],
          ['With open deals',
            crm.companies.filter(c => crm.deals.some(d => d.cid === c.id && isOpen(d))).length,
            'zap', 'g-green'],
          ['Now clients',
            crm.companies.filter(c => rows.some(r => r.name === c.name)).length,
            'check', 'g-purple'],
          ['Pipeline', fmtMoney(pipeline.pipeline), 'chart', 'g-blue']
        ]}
      />

      <CrmFilter kind="company" />

      <Card>
        <CardHead icon="building" tone="g-cyan" title="Companies" count={list.length}>
          <ViewToggle view="companies" />
        </CardHead>

        {crmMode.companies === 'list' ? (
          <CompanyTable list={list} />
        ) : list.length ? (
          <div className="cards">
            {list.map(c => {
              const open = crm.deals.filter(d => d.cid === c.id && isOpen(d));
              const isClient = rows.some(r => r.name === c.name);
              return (
                <div className="ccard" key={c.id} onClick={() => setSheet({ kind: 'company', id: c.id })}>
                  <div className="top2">
                    <div className={`who ${avatarClass(c.name)}`}><Icon name="building" /></div>
                    <div className="tmeta">
                      <b>{c.name}</b>
                      <small>{[c.industry, c.city].filter(Boolean).join(' · ') || 'No industry set'}</small>
                    </div>
                  </div>
                  <div className="pills">
                    <Pill tone="p-blue">{open.length} open</Pill>
                    <Pill tone="p-purple">{fmtMoney(open.reduce((t, d) => t + (+d.value || 0), 0))}</Pill>
                    {isClient ? <Pill tone="p-green" icon="check">Client</Pill> : null}
                  </div>
                  <div className="foot">
                    <span>{c.owner || 'Unowned'}</span>
                    <span>{crm.contacts.filter(x => x.cid === c.id).length} contacts</span>
                  </div>
                </div>
              );
            })}
          </div>
        ) : (
          <EmptyState icon="building" tone="g-cyan" title="No companies match">
            Clear the filters, or add one.
          </EmptyState>
        )}
      </Card>
    </>
  );
}
